import { SystemStyleObject } from '@chakra-ui/react';
import { createContext } from '@chakra-ui/react-utils';

import type { EmptyPart } from './types';

export type EmptyStyles = Partial<Record<EmptyPart, SystemStyleObject>>;

const [EmptyStylesContextProvider, useEmptyStyles] = createContext<EmptyStyles>(
  {
    name: 'EmptyStylesContext',
    errorMessage:
      'useEmptyStyles: `context` is undefined. Seems you used an Empty sub-component that required a styles context outside of an Empty component.',
  },
);

export { EmptyStylesContextProvider, useEmptyStyles };
